/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useCallback, useEffect, useRef, useState } from "react";

export const useTimeCounterCallback = (seconds: number, onEnd: () => void) => {
  const [timeLeft, setTimeLeft] = useState(seconds);

  const timeLeftRef = useRef<number>(seconds);
  const intervalRef = useRef<number>();
  const mountRef = useRef<boolean>(false);

  const percent = Math.min((seconds - timeLeft) / (seconds - 1), 1);

  const stopTimer = useCallback(() => {
    if (intervalRef.current) {
      clearTimeout(intervalRef.current);
    }
  }, []);

  const startTimer = useCallback(() => {
    intervalRef.current = window.setInterval(() => {
      if (mountRef.current && timeLeftRef.current <= 0) {
        onEnd();
        stopTimer();
      }
      timeLeftRef.current -= 1;
      mountRef.current && setTimeLeft(timeLeftRef.current);
    }, 1000);
  }, [onEnd, stopTimer]);

  useEffect(() => {
    mountRef.current = true;

    return () => {
      mountRef.current = false;
    };
  }, []);

  useEffect(() => {
    startTimer();

    return () => stopTimer();
  }, [startTimer, stopTimer]);

  return { timeLeft, percent };
};
